import { SHOW_AMAZON_RATINGS } from "../config/amazonDataAvailability.js";
import s from "./ReminderRecoCarousel.module.css";

function starClass(rating, position) {
  if (rating >= position - 0.25) return "fa-solid fa-star";
  if (rating >= position - 0.75) return "fa-solid fa-star-half-stroke";
  return "fa-regular fa-star";
}

/**
 * Rating row for reco cards: real star fill from the product's Amazon rating plus its
 * review count. Gated behind `SHOW_AMAZON_RATINGS` — these are scraped snapshots that
 * drift out of date without the Amazon Product Advertising API, so we hide them for now.
 * Also renders nothing when a card carries neither value (e.g. a legacy saved doc).
 */
export default function RecoRatingStars({ rating, reviewCount }) {
  if (!SHOW_AMAZON_RATINGS) return null;
  const value = Number(rating);
  const hasRating = Number.isFinite(value) && value > 0;
  if (!hasRating && !reviewCount) return null;

  return (
    <div className={s.compactReviewRow}>
      {hasRating ? (
        <div className={s.compactStars} aria-label={`${value} out of 5 stars`}>
          {[1, 2, 3, 4, 5].map((position) => (
            <i key={position} className={starClass(value, position)} />
          ))}
        </div>
      ) : null}
      {reviewCount ? (
        <span className={s.compactReviewText}>{reviewCount}</span>
      ) : null}
    </div>
  );
}
